//トップページ　キービジュアルスライダー

export function newsFunc() {
  let newsTop = $("#newsTop").length;
  let resizecheck = $('#responsibleCheck').width();

  if(newsTop){
    const newsArchivesBtn = $('#newsArchivesBtn');
    let resizecheck = $('#responsibleCheck').width();
    let resizecheck2 = 0;

    newsArchivesBtn.on('click', function () {
      if ($(this).hasClass('isOpen')) {
        $(this).next('dd').slideUp(500);
        $(this).removeClass('isOpen');
      } else {
        $(this).next('dd').slideDown(500);
        $(this).addClass('isOpen');
      }
    });
  }
}